import type { BookingConfirmationExtra } from '@massilia/queries'

import { Download, Package } from 'lucide-react'

import { centsToEuros, formatPrice } from '@/utils/format-price'

interface ExtrasSectionProps {
  extras: BookingConfirmationExtra[]
}

export function ExtrasSection({ extras }: ExtrasSectionProps) {
  if (extras.length === 0) return null

  return (
    <div className="border-gray-light-200 flex flex-col gap-3 rounded-2xl border bg-white p-6">
      <div className="text-gray-light-900 text-lg leading-7 font-semibold sm:text-2xl">
        Prestations supplémentaires
      </div>

      {extras.map((extra, i) => (
        <div key={i} className="border-gray-light-200 flex flex-col gap-3 rounded-xl border p-4">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="flex size-9 items-center justify-center rounded-lg bg-indigo-50">
                <Package className="size-5 text-indigo-500" />
              </div>
              <div className="flex flex-col">
                <span className="text-gray-light-900 text-sm font-semibold">{extra.name}</span>
                {extra.description && (
                  <span className="text-gray-light-600 text-xs font-medium">
                    {extra.description}
                  </span>
                )}
                {extra.providerName && (
                  <span className="text-gray-light-600 text-xs font-medium">
                    Prestataire : {extra.providerName}
                  </span>
                )}
                {extra.providerExternalRef && (
                  <span className="text-gray-light-600 text-xs font-medium">
                    Réf. : {extra.providerExternalRef}
                  </span>
                )}
              </div>
            </div>
            <span className="text-gray-light-900 shrink-0 text-sm font-bold">
              {formatPrice(centsToEuros(extra.price))}
            </span>
          </div>

          {/* File download link */}
          <a
            className="text-brand-600 hover:text-brand-700 flex items-center gap-1.5 text-xs font-medium"
            href={extra.fileUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Download className="size-3.5" />
            <span className="max-w-[250px] truncate">{extra.fileName}</span>
          </a>
        </div>
      ))}
    </div>
  )
}
